import React from 'react'
import { Switch } from 'react-router-dom'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'

import BankHolidaysList from './List'
import NewHoliday from './NewHoliday'
import EditHoliday from './EditHoliday'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_BANK_HOLIDAYS } from 'app-support/permissions/Permissions'
import { bankHolidaysRoute, bankHolidaysRouteEdit, bankHolidaysRouteNew } from 'routes/routeNames'

const enhance = withRegionSwitchHandler(bankHolidaysRoute)

const BankHolidaysContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_BANK_HOLIDAYS} exact path={bankHolidaysRouteNew} component={NewHoliday} />
    <PermissionRoute permission={PERMISSION_MANAGE_BANK_HOLIDAYS} exact path={bankHolidaysRouteEdit} component={EditHoliday} />
    <PermissionRoute permission={PERMISSION_MANAGE_BANK_HOLIDAYS} exact path={bankHolidaysRoute} component={BankHolidaysList} />
  </Switch>
)

export default enhance(BankHolidaysContainer)
